export default __webpack_public_path__ + "static/media/The Horizon's Severing Divide.e4e82f9c.jpg";